import request from "../request"
//获取表格数据
function getPageList(data) {
    return request({
        method: 'post',
        url: '/feedback/page',
        data
    })

}
export { getPageList }

